// src/frontend/src/components/Layout/Footer.tsx - Dark theme matching navbar

import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      {/* Newsletter CTA Section - Neutral dark design */}
      <div className="bg-gray-800 py-20">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-5xl font-bold mb-6">START PRACTICING TODAY.</h2>
          <p className="text-gray-300 mb-8 text-xl max-w-2xl mx-auto">
            Join 10,000+ PMs mastering stakeholder conversations with AI-powered coaching
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-6 py-4 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 text-center sm:text-left"
            />
            <button className="px-8 py-4 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition-colors shadow-lg">
              Get Started →
            </button>
          </div>
          <p className="text-gray-400 text-sm mt-4">
            By proceeding you agree to our <Link to="/terms-of-service" className="underline hover:text-gray-200">Platform Terms</Link> & <Link to="/privacy-policy" className="underline hover:text-gray-200">Privacy Notice</Link>
          </p>
        </div>
      </div>

      {/* Main Footer - Dark theme */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        {/* Logo Section */}
        <div className="mb-16">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center mr-4">
              <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <span className="text-2xl font-bold">PM Coach</span>
          </div>
          
          {/* Social Icons */}
          <div className="flex space-x-4">
            <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors group">
              <svg className="w-5 h-5 text-gray-400 group-hover:text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
            </a>
            <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors group">
              <svg className="w-5 h-5 text-gray-400 group-hover:text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
            <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors group">
              <svg className="w-5 h-5 text-gray-400 group-hover:text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/></svg>
            </a>
          </div>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          <div>
            <h3 className="text-white font-bold mb-4">Products</h3>
            <ul className="space-y-3">
              <li><Link to="/features/ai-coaching" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">AI Coaching</Link></li>
              <li><Link to="/features/stakeholder-simulations" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Stakeholder Simulations</Link></li>
              <li><Link to="/features/learning-tracks" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Learning Tracks</Link></li>
              <li><Link to="/features/performance-analytics" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Performance Analytics</Link></li>
              <li><Link to="/features/team-management" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Team Management</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-purple-400 transition-colors text-sm font-medium">Pricing</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Compare</h3>
            <ul className="space-y-3">
              <li><Link to="/vs/betterup" className="text-gray-400 hover:text-green-400 transition-colors text-sm">vs BetterUp</Link></li>
              <li><Link to="/vs/coachhub" className="text-gray-400 hover:text-green-400 transition-colors text-sm">vs CoachHub</Link></li>
              <li><Link to="/vs/executive-coaching" className="text-gray-400 hover:text-green-400 transition-colors text-sm">vs Executive Coaching</Link></li>
              <li><Link to="/vs/traditional-pm-training" className="text-gray-400 hover:text-green-400 transition-colors text-sm">vs Traditional Training</Link></li>
              <li><Link to="/alternatives/pm-certification" className="text-gray-400 hover:text-green-400 transition-colors text-sm">vs PM Certification</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Solutions</h3>
            <ul className="space-y-3">
              <li><Link to="/solutions/new-project-managers" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">New PMs</Link></li>
              <li><Link to="/solutions/senior-project-managers" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Senior PMs</Link></li>
              <li><Link to="/solutions/pmo-leaders" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">PMO Leaders</Link></li>
              <li><Link to="/solutions/pm-interview-prep" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Interview Prep</Link></li>
              <li><Link to="/solutions/stakeholder-management" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Stakeholder Management</Link></li>
              <li><Link to="/solutions/scope-creep-management" className="text-gray-400 hover:text-purple-400 transition-colors text-sm">Scope Creep</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Industries</h3>
            <ul className="space-y-3">
              <li><Link to="/industries/technology" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Technology</Link></li>
              <li><Link to="/industries/healthcare" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Healthcare</Link></li>
              <li><Link to="/industries/consulting" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Consulting</Link></li>
              <li><Link to="/industries/financial-services" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Financial Services</Link></li>
              <li><Link to="/industries/construction" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Construction</Link></li>
              <li><Link to="/industries/manufacturing" className="text-gray-400 hover:text-orange-400 transition-colors text-sm">Manufacturing</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Resources</h3>
            <ul className="space-y-3">
              <li><Link to="/resources/pm-best-practices" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">PM Best Practices</Link></li>
              <li><Link to="/resources/pm-career-guide" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Career Guide</Link></li>
              <li><Link to="/resources/stakeholder-management-guide" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Stakeholder Guide</Link></li>
              <li><Link to="/resources/pm-skills-assessment" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Skills Assessment</Link></li>
              <li><Link to="/resources/case-studies" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Case Studies</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-blue-400 transition-colors text-sm">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Support</h3>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-gray-400 hover:text-red-400 transition-colors text-sm">Help Center</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-red-400 transition-colors text-sm">Contact Us</Link></li>
              <li><Link to="/pricing#faq" className="text-gray-400 hover:text-red-400 transition-colors text-sm">FAQ</Link></li>
              <li><a href="#" className="text-gray-400 hover:text-red-400 transition-colors text-sm">System Status</a></li>
            </ul>
          </div>
        </div>

        {/* Company & Legal Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12 pt-12 border-t border-gray-800">
          <div>
            <h3 className="text-white font-bold mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">About Us</Link></li>
              <li><Link to="/about#careers" className="text-gray-400 hover:text-white transition-colors text-sm">Careers</Link></li>
              <li><Link to="/about#press" className="text-gray-400 hover:text-white transition-colors text-sm">Press</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">Partners</Link></li>
              <li><Link to="/logo-download" className="text-gray-400 hover:text-white transition-colors text-sm">Brand Assets</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4">Legal</h3>
            <ul className="space-y-3">
              <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors text-sm">Terms of Service</Link></li>
              <li><Link to="/security" className="text-gray-400 hover:text-white transition-colors text-sm">Security</Link></li>
              <li><a href="/sitemap.xml" className="text-gray-400 hover:text-white transition-colors text-sm">Sitemap</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-white font-bold mb-4">Security & Trust</h3>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-sm text-gray-400">SSL Encrypted</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-sm text-gray-400">GDPR Compliant</span>
              </div>
              <div className="flex items-center space-x-2">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                  <path fillRule="evenodd" d="M4 5a2 2 0 012-2 1 1 0 000 2H6a2 2 0 00-2 2v6a2 2 0 002 2h2a1 1 0 100-2H6V7h8v6h-2a1 1 0 100 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a1 1 0 100-2h2a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V5z" clipRule="evenodd" />
                </svg>
                <span className="text-sm text-gray-400">SOC 2 Type II</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 py-6 bg-black">
        <div className="max-w-6xl mx-auto px-4 flex flex-col lg:flex-row justify-between items-center">
          <div className="text-gray-500 text-sm mb-4 lg:mb-0">
            ©2010-{new Date().getFullYear()} All Rights Reserved. PM Coach™ is a trademark of PM Coach, Inc.
          </div>
          <div className="flex items-center space-x-2 bg-gray-900 px-4 py-2 rounded-lg">
            <span className="text-gray-500 text-sm">Built with AI by</span>
            <a 
              href="https://aiguruhq.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 transition-colors text-sm font-medium flex items-center space-x-2"
            >
              <span>AI Guru™</span>
              <div className="w-5 h-5 bg-gradient-to-r from-blue-500 to-purple-600 rounded flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;